import type { GamePlayerProjectionTrading } from '@library/types/trading';
import { PlayerModalProjectionRow } from '@bo-components/playerModal/PlayerModalProjectionRow';
import type { SelectOption } from '@library/types/utils';
import { findProjectionByProjectionId } from '@bo-utils/projection';

export interface PlayerModalStatTableProps {
  changes: Array<Partial<GamePlayerProjectionTrading>>;
  onResetCreateProjections: () => void;
  projections: Array<GamePlayerProjectionTrading>;
  newProjections: Array<GamePlayerProjectionTrading>;
  updateProjection: ({
    change,
    initialProjection
  }: {
    change: Partial<GamePlayerProjectionTrading>;
    initialProjection: GamePlayerProjectionTrading;
  }) => void;
  updateNewProjection: ({
    change,
    initialProjection
  }: {
    change: Partial<GamePlayerProjectionTrading>;
    initialProjection: GamePlayerProjectionTrading;
  }) => void;
  statTypes: Array<SelectOption>;
  isDisplayTimeVisible: boolean;
}

export const PlayerModalStatTable = ({
  changes,
  newProjections,
  onResetCreateProjections,
  projections,
  updateProjection,
  updateNewProjection,
  statTypes,
  isDisplayTimeVisible
}: PlayerModalStatTableProps) => {
  return (
    <table className="w-full table-auto text-[14px] font-normal">
      <tbody className="border-soFresh-140 border-b">
        {projections?.map((projection) => {
          const change = findProjectionByProjectionId({
            projectionArray: changes,
            projectionId: projection.projectionId
          });

          return (
            <PlayerModalProjectionRow
              change={change}
              key={`${projection.projectionId}-row`}
              onResetCreateProjections={onResetCreateProjections}
              projection={projection}
              updateProjection={updateProjection}
              statTypes={statTypes}
              isDisplayTimeVisible={isDisplayTimeVisible}
            />
          );
        })}
        {newProjections?.map((projection) => {
          return (
            <PlayerModalProjectionRow
              key={`${projection.projectionId}-row`}
              onResetCreateProjections={onResetCreateProjections}
              projection={projection}
              updateProjection={updateNewProjection}
              statTypes={statTypes}
              isDisplayTimeVisible={isDisplayTimeVisible}
            />
          );
        })}
      </tbody>
    </table>
  );
};
